import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {NgOptimizedImage, NgClass} from '@angular/common';

@Component({
	selector: 'app-select-trigger',
	templateUrl: './select-trigger.component.html',
	styleUrls: ['../multi-select.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgOptimizedImage, NgClass]
})
export class SelectTriggerComponent {
	@Input() appearance: 'chips' | 'chips-v2' | 'field' = 'chips';
	@Input() icon?: `assets/${string}.svg` | `assets/${string}.png`;
	@Input() minHeight?: number;
	@Input() border?: string;
	@Input() error = false;
	@Input() warning = false;
	@Input() readonly = false;
}
